import { CardContent } from '../content.types';
import { dataFor } from '../data';
import { useLanguage } from './use-content';

export interface UseCardContentResult {
  cardData?: CardContent;
  isLoading: boolean;
}

export function useCardContent(id?: string): UseCardContentResult {
  const language = useLanguage();
  const cards = dataFor('cards', language);
  const cardData = id ? cards[id] : undefined;
  return { cardData, isLoading: false };
}

export function useCardContentGroup(groupId?: string): {
  items: CardContent[];
  isLoading: boolean;
} {
  const language = useLanguage();
  const cards = dataFor('cards', language);
  if (!groupId) {
    return { items: [], isLoading: false };
  }
  const card = cards[groupId];
  return { items: card ? [card] : [], isLoading: false };
}
